import Controller from './controller';

App.Widgets.setWidgetStarterInNamespace('WidgetSectionDownload', Controller);



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-form-sections/widget-dfa-download/scripts/index.js